import { useFilterEmployeePaymentContext } from "./filter-employee-payment.context";

export function FilterEmployeePayment() {
  const { dateFilterElement, clearFiltersElement } =
    useFilterEmployeePaymentContext();

  return (
    <div>
      <h2>Filters</h2>
      <p className="mb-4">
        Select the following filters you want to apply to the current table.
      </p>

      {dateFilterElement}
      {clearFiltersElement}
    </div>
  );
}